import { createSelectorHook, createDispatchHook, createStoreHook } from 'react-redux';
import { StoreContext } from './storeContext';
import { WidthsStoreContext } from './widthsStoreContext';
import { SelectionStoreContext } from './selectionStoreContext';
import { CellSelectionStoreContext } from './cellSelectionStoreContext';
export const useWidthsSelector = createSelectorHook(WidthsStoreContext);
export const useWidthsDispatch = createDispatchHook(WidthsStoreContext);
export const useSelectionSelector = createSelectorHook(SelectionStoreContext);
export const useSelectionDispatch = createDispatchHook(SelectionStoreContext);
export const useCellSelectionSelector = createSelectorHook(CellSelectionStoreContext);
export const useCellSelectionDispatch = createDispatchHook(CellSelectionStoreContext);
export const useCellSelectionStore = createStoreHook(CellSelectionStoreContext);
export const useTableSelector = createSelectorHook(StoreContext);
export const useTableDispatch = createDispatchHook(StoreContext);